<template>
<v-layout :class="{'in-dialog': !!dialog}" row wrap>
  <v-flex
    column
    sm4
    xs12
    class="mese"
    v-for="mese in data"
    @mouseenter="modalitaEstesa && coming(mese.mese)"
    @mouseleave="modalitaEstesa && leaving(mese.mese)"
    :key="mese.mese">
    <transition-group name="fade" tag="div">
      <div class="toggler" key="indle" v-if="!togglers[mese.mese]">
        <v-layout>
          <v-flex class="progress">
            <v-progress-circular
              :rotate="360"
              :size="70"
              :width="6"
              :value="Math.min((mese.corr[2] / mese.prec[2] * 100) || 0, 100)"
              color="primary">
              <span :class="{'success--text': mese.corr[2] / mese.prec[2] >= 1}">
                {{ ((mese.corr[2] / mese.prec[2] * 100) || 0).toFixed("0") }} %
              </span>
            </v-progress-circular>
          </v-flex>
          <v-flex>
            <v-card-title primary-title>
              <div>
                <div class="subheading">{{ mese.nome }}</div>
                <div class="title">{{ mese.corr[2] | currency({ fractionCount: 0 }) }}</div>
              </div>
            </v-card-title>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 style="text-align: center;">
            <div class="separator"></div>
            <span class="caption">
              Anno prec. {{ mese.prec[2] | currency({ fractionCount: 0 }) }}</span>
          </v-flex>
        </v-layout>
      </div>
      <div class="toggler" key="hover" v-if="togglers[mese.mese]">
        <v-layout>
          <v-flex>
            <v-card-title style="justify-content: center;" primary-title>
              <div>
                <div class="subheading"> Fiscale </div>
                <div class="title">{{ mese.corr[0] | currency({ fractionCount: 0 }) }}</div>
              </div>
            </v-card-title>
          </v-flex>
          <v-flex>
            <v-card-title style="justify-content: center;" primary-title>
              <div>
                <div class="subheading"> Gestionale </div>
                <div class="title">{{ mese.corr[1] | currency({ fractionCount: 0 }) }}</div>
              </div>
            </v-card-title>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs6 style="text-align: center;">
            <div class="separator"></div>
            <span class="caption">
              {{ mese.prec[0] | currency({ fractionCount: 0 }) }}</span>
          </v-flex>
          <v-flex xs6 style="text-align: center;">
            <div class="separator"></div>
            <span class="caption">
              {{ mese.prec[1] | currency({ fractionCount: 0 }) }}</span>
          </v-flex>
        </v-layout>
      </div>
    </transition-group>
  </v-flex>
</v-layout>
</template>

<script>
export default {
  name: 'tot-mensile-detail',
  props: ['data', 'dialog'],
  data() {
    return {
      togglers: {},
    };
  },
  methods: {
    coming(month) {
      this.$set(this.togglers, month, true);
    },
    leaving(month) {
      this.$delete(this.togglers, month);
    },
  },
};
</script>

<style lang="stylus" scoped>
.mese
  position relative
  height 126px
  cursor pointer
  padding 5px 0
  .progress
    display flex
    justify-content center
    align-items center
    flex 1
  .fiscale
    flex 1.5
  .v-progress-circular
    >>> div
      min-width 50px
      text-align center
  .separator
    width 80%
    height 1px
    background #ddd
    left 0
    right 0
    margin auto
  .toggler
    position absolute
    margin auto
    right 0
    left 0
    top 5px
    bottom 5px
.in-dialog
  display flex
  flex-wrap wrap
  justify-content space-between
  padding 10px
</style>
